export default __webpack_public_path__ + "i18n/translation-gu.a62014c5.json";